import '../images';
import '../svgs';

import './modules';
import './components';
import { renderPaywall, renderAds } from './tools/utilities';
import RemoveFocusState from 'remove-focus-state';

document.getElementsByClassName('no-js')[0].classList.remove('no-js');

renderPaywall();
renderAds();

new RemoveFocusState();
